// extracted by mini-css-extract-plugin
export default {"apiErrorMessage":"webpack-pages-EligibilityCriteria-components-ExclusionsModal-ExclusionModal-module__apiErrorMessage"};